import "./css/form.css";
import { useForm } from "react-hook-form";
import errorIcon from "./img/icon/errorIcon.png";
import SubHeader from "../components/subHeader4";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import React, { useRef, useEffect, useState } from "react";
import Cookies from "universal-cookie";


const cookies = new Cookies();

/* 전화번호 포맷 */
function formatPhoneNumber(value) {
  if (!value) return value;

  // 숫자가 아닌 input값 제거
  const phoneNumber = value.replace(/[^\d]/g, "");

  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return  숫자 길이가 4보다 크고 7보다 작으면 포맷
  // the formatted number
  if (phoneNumberLength < 8) {
    return `${phoneNumber.slice(0, 3)} - ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `${phoneNumber.slice(0, 3)} - ${phoneNumber.slice(
    3,
    7
  )} - ${phoneNumber.slice(7, 11)}`;
}

const Inquiry = () => {
  const [inputValue, setInputValue] = useState("");

  const [checked, setChecked] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  const verify = () => {
    captchaRef.current.getResponse().then((res) => {
      setCaptchaToken(res);
    });
  };
  const onSubmit = async (data) => {
    const token = captchaRef.current.getValue();
    captchaRef.current.reset();
    //captcha가 체크됐을 때만
    if (token !== "") {
      await axios
        .post("https://thegmmedical.com:5002/api/token", { token })
        .then((res) => {
          console.log(res);
          if (res.data.responseDesc === "Success") {
            document.inquiry_form.submit();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleInput = (e) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setInputValue(formattedPhoneNumber);
  };

  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  function onChange(value) {
    console.log("Captcha value:", value);
  }
  return (
    <div className="wrapper">
      <SubHeader />
      <h1 className="headerText">{i18next.t("inquiry.title")}</h1>
      <div className="ContactForm">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="contactForm">
                <form
                  id="inquiry-form"
                  name="inquiry_form"
                  action="https://thegmmedical.com:5002/api/inquiry"
                  method="post"
                  onSubmit={handleSubmit(onSubmit)}
                  acceptCharset="UTF-8"
                  noValidate
                >
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {i18next.t("inquiry.form.company")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="company"
                          {...register("company", {
                            required: {
                              value: "Required",
                              message: "회사명을 입력해주세요.",
                            },
                            pattern: {
                              value: "^[a-zA-Z]+$",
                              message: "회사명을 입력해주세요.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Please use 30 characters or less",
                            },
                          })}
                          className="form-control formInput"
                          required
                        ></input>
                        {errors.name && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.name.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {i18next.t("inquiry.form.name")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="name"
                          {...register("name", {
                            required: {
                              value: "Required",
                              message: "이름을 입력해주세요.",
                            },
                            pattern: {
                              value: "^[a-zA-Z]+$",
                              message: "이름을 입력해주세요.",
                            },
                            maxLength: {
                              value: 30,
                              message: "Please use 30 characters or less",
                            },
                          })}
                          className="form-control formInput"
                          required
                        ></input>
                        {errors.name && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.name.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {" "}
                        {i18next.t("inquiry.form.email")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          className="form-control formInput"
                          name="email"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "이메일을 입력해 주세요.",
                            },
                            maxLength: {
                              message: "Please use 30 characters or less",
                            },
                            pattern: {
                              value:
                                /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i,
                              message: "이메일 형식이 올바르지 않습니다",
                            },
                          })}
                        ></input>
                        {errors.email && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.email.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row formRow">
                    <div className="col phone">
                      <label htmlFor="type" className="form_tit">
                        {i18next.t("inquiry.form.tel")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="tel"
                          value={inputValue}
                          {...register("tel", {
                            required: "전화번호를 입력해 주세요.",
                            onChange: (e) => {
                              handleInput(e);
                            },
                          })}
                          className="form-control formInput"
                        ></input>
                        {errors.tel && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.tel.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {i18next.t("inquiry.form.product")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <input
                          type="text"
                          name="subject"
                          {...register("subject", {
                            required: {
                              value: true,
                              message: "제품명을 입력해 주세요.",
                            },
                            maxLength: {
                              value: 75,
                              message: "Subject cannot exceed 75 characters",
                            },
                          })}
                          className="form-control formInput"
                        ></input>

                        {errors.subject && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.subject.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row formRow">
                    <div className="col">
                      <label htmlFor="type" className="form_tit">
                        {" "}
                        {i18next.t("inquiry.form.message")}
                        <span className="point_txt">*</span>
                      </label>
                      <div className="col_wrap">
                        <textarea
                          rows={10}
                          name="content"
                          {...register("content", {
                            required: {
                              value: true,
                              message: "내용을 입력해 주세요.",
                            },
                          })}
                          className="form-control formInput"
                        ></textarea>

                        {errors.content && (
                          <div className="form_error_wrap">
                            <p className="form_error">
                              <img src={errorIcon} alt="error_icon"></img>
                              {errors.content.message}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="reCAPTCHA">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey= {process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={onChange}
                    />
                  </div>
                  <div className="contact_agree">
                    <p className="tit">
                    {i18next.t("inquiry.consent")}{" "}
                      <span className="point_txt">*</span>
                    </p>
                    <div className="">
                    {i18next.t("inquiry.consent_1")} <br />
                      <br />
                      {i18next.t("inquiry.consent1")}
                      <br />
                  
                      {i18next.t("inquiry.consent1-1")}
                      <br />
                      {i18next.t("inquiry.consent1-2")}
                      <br />
                      {i18next.t("inquiry.consent1-3")}
                      <br />
                      {i18next.t("inquiry.consent1-4")}
                      <br />
                      {i18next.t("inquiry.consent1-5")} <p></p>
                      <p>
                      {i18next.t("inquiry.consent2")}
                        <br />
                        {i18next.t("inquiry.consent2-1")}
                        <br />
                        {i18next.t("inquiry.consent2-2")}
                        <br />
                        {i18next.t("inquiry.consent2-3")}
                        <br />
                        {i18next.t("inquiry.consent2-4")}
                      </p>
                      <p>
                      {i18next.t("inquiry.consent3")}
                        <br />
                        {i18next.t("inquiry.consent3-1")}
                        <br />
                        {i18next.t("inquiry.consent3-2")}
                        <br />
                        {i18next.t("inquiry.consent3-3")}
                        <br />{i18next.t("inquiry.consent3-4")}{" "}
                      </p>
                    </div>
                  </div>
                  <div className="agree_check">
                    <input
                      type="checkbox"
                      name="acceptance"
                      defaultChecked={checked}
                      onChange={() => setChecked(!checked)}
                      id="acceptance"
                      aria-invalid="false"
                      {...register("acceptance", {
                        required: {
                          value: true,
                          message: "동의가 필요합니다.",
                        },
                      })}
                    />
                    <label htmlFor="acceptance"></label>
                    {errors.acceptance && (
                      <div className="form_error_wrap" style={{position:"absolute", top:"25px"}}>
                      <p className="form_error">
                          <img src={errorIcon} alt="error_icon"></img>
                          {errors.acceptance.message}
                        </p>
                      </div>
                    )}
                    <span>{i18next.t("inquiry.agree")} </span>{" "}
                    <span className="point_txt">*</span>
                  </div>

                  <input
                    className="submit-btn"
                    type="submit"
                    value={i18next.t("inquiry.button")} 
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inquiry;
